<button class="e-close-button" aria-label="Close infographics dialog" (click)="closeModal()">
    <i class="fa-regular fa-xmark"></i>
</button>

<ng-container [ngSwitch]="infographicsName">
    <via-search-infographics *ngSwitchCase="'search'"></via-search-infographics>
    <via-export-infographics *ngSwitchCase="'export'"></via-export-infographics>
    <!--<via-insights-infographics *ngSwitchCase="'insights'"></via-insights-infographics>-->
</ng-container>
